import axios, {AxiosResponse} from "axios";
import get from "lodash-es/get";
import { MessageResponse } from "app/api/types";
import config from "app/api/axiosConfig";

export default (token: string, clientId: number) =>
	axios.get(`${process.env.REACT_APP_CHAT_HOST}/Api/Messages/${clientId}`, config(token))
		.then((response: AxiosResponse) => {
			const messages: MessageResponse[] = get(response, "data", {});
			return Promise.resolve(messages)
		})
